// Home.js
import React from 'react';
import Layout from '../layout/Layout';
import HeroSection from '../components/Home/HeroSection.js';
import FeaturesSection from '../components/Home/FeaturesSection.js';
import Testimonial from '../components/Home/Testimonial';

function Home() {
  return (
    <Layout>
      <HeroSection />
      <FeaturesSection />
      <Testimonial />
    </Layout>
  );
}

export default Home;
